import { Component, OnInit, OnDestroy } from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import { retry } from 'rxjs/operators';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import swal from 'sweetalert2';
import { User } from '../../models/user.model';
import { AdminService } from '../../services/admin/admin.service';

@Component({
  selector: 'app-account-settings',
  templateUrl: './account-settings.component.html',
  styles: []
})

export class AccountSettingsComponent implements OnInit, OnDestroy {

  accountForm: FormGroup;
  subs: Subscription;
  user: User = new User('', '', true, 0, false, '');

  constructor(public adminService: AdminService) {

    // this.promise().then( () => console.log('Finished'),
    // ).catch(err => console.error('Error', err));

    // this.subs = this.obs().pipe(
    //   retry(2)
    //   ).subscribe(
    //   num => console.log('Subs ', num),
    //   err => console.log('Error ', err),
    //   () => console.log('OBS Finished ')
    // );

  }

  ngOnInit() {

    this.getAdmin();
    console.log(this.user.email);

    this.accountForm = new FormGroup({
      name: new FormControl(null, Validators.required),
      lastname: new FormControl(null, Validators.required),
      email: new FormControl(null, [Validators.email, Validators.required])
    });

  }

  ngOnDestroy() {
    //this.subs.unsubscribe();
  }

  //QUEDE ACA MANDANDO EL EMAIL A ACCOUNT STTINGS.

  getAdmin() {

    // const adminId = this.cognitoUtil.getCurrentUser().getUsername();
    // console.log(adminId + ' ADMIN ID');
    // this.adminService.searchAdminId(adminId).subscribe((res: any) => {
    //   console.log(JSON.parse(res.body));
    //   this.user = (JSON.parse(res.body))[0];
    //   console.log(this.user.email);
    // });

  }

  editUser() {
    swal.fire({
      title: 'Error!',
      text: 'Do you want to continue',
      type: 'error',
      confirmButtonText: 'Cool'
    });
    console.log(this.accountForm.value);
  }

  promise() {
    const promise = new Promise((resolve, reject) => {

      let count = 0;

      const interval = setInterval(() => {

        count += 1;
        console.log('Contador: ', count);
        if (count === 3) {
          resolve();
          clearInterval(interval);
        }
      }, 1000);
    });

    return promise;
  }

  obs() {
    const obs = new Observable(observer => {

      let count = 0;

      const interval = setInterval(() => {
        count += 1;
        observer.next(count);
        if (count === 3) {
          clearInterval(interval);
          observer.complete();
        }
        if (count === 2) {
          clearInterval(interval);
          observer.error('Error OBS');
        }
      }, 1000);
    });
    return obs;
  }
}
